function koyoPackTotals(config, quantity, cartQuantity = 0) {
  if (!config.available || ![5, 10, 100].includes(config.packCount)) return null;
  if (!Number.isSafeInteger(quantity) || quantity < 1 || !Number.isSafeInteger(cartQuantity) || cartQuantity < 0 || !Number.isSafeInteger(quantity + cartQuantity)) return null;
  let price = config.price;
  let minimum = 0;
  for (const priceBreak of config.priceBreaks || []) {
    if (priceBreak.minimum <= quantity + cartQuantity && priceBreak.minimum > minimum) {
      price = priceBreak.price;
      minimum = priceBreak.minimum;
    }
  }
  const subtotal = price * quantity;
  const burs = config.packCount * quantity;
  if (!Number.isSafeInteger(price) || price < 0 || !Number.isSafeInteger(subtotal) || !Number.isSafeInteger(burs)) return null;
  return { packs: quantity, burs, subtotal };
}

function koyoPackMoney(cents, locale, currency) {
  return new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'code' }).format(cents / 100);
}

if (!customElements.get('koyo-pack-comparison')) {
  customElements.define('koyo-pack-comparison', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.onQuantityChange = (event) => {
        if (event.target === this.productInfo?.querySelector('.quantity__input')) this.refresh();
      };
      this.productInfo?.addEventListener('input', this.onQuantityChange);
      this.productInfo?.addEventListener('change', this.onQuantityChange);
      this.quantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.refresh());
      this.optionUnsubscribe = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data: { event } }) => {
        if (this.productInfo?.contains(event.target)) this.hidden = true;
      });
      this.refresh();
    }

    disconnectedCallback() {
      this.productInfo?.removeEventListener('input', this.onQuantityChange);
      this.productInfo?.removeEventListener('change', this.onQuantityChange);
      this.quantityUnsubscribe?.();
      this.optionUnsubscribe?.();
    }

    refresh(variantUpdated = false) {
      const total = this.querySelector('[data-pack-total]');
      const configNode = this.querySelector('[data-pack-config]');
      if (variantUpdated) this.hidden = !configNode;
      if (!total || !configNode) return;
      total.hidden = true;
      try {
        const config = JSON.parse(configNode.textContent);
        const input = this.productInfo?.querySelector('.quantity__input');
        if (input && !input.checkValidity()) return;
        const totals = koyoPackTotals(config, input ? Number(input.value) : 1, Number(input?.dataset.cartQuantity || 0));
        if (!totals) return;
        this.querySelector('[data-pack-count]').textContent = config.countLabel
          .replace('[packs]', totals.packs).replace('[burs]', totals.burs);
        this.querySelector('[data-pack-subtotal]').textContent = koyoPackMoney(totals.subtotal, config.locale, config.currency);
        total.hidden = false;
      } catch (error) {
        console.error('Unable to display pack total', error);
      }
    }
  });
}
